

export enum ParticipantStatus {
  pending = 'pending',
  confirmed = 'confirmed',
  denied = 'denied',
  invited = 'invited',
}